import type { OrderListResultData } from '@frontend/api';
import { Text } from '@frontend/components';

import { formatPrice } from 'utils/formatters';

type PriceCellContentProps = {
  rowData: OrderListResultData;
};

export const PriceCellContent = ({ rowData }: PriceCellContentProps) => (
  <Text fontFamily="data">{formatPrice(rowData.totalPrice)}</Text>
);
